module.exports = __webpack_public_path__ + "img/saddledbichir.10fdec1d.png";